firebird.directive('trackIframeClick', [
    '$rootScope',
    '$window',
    'logService',
    'analyticsWrapperService',
    function ($rootScope, $window, logService, analyticsWrapperService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var iframeMouseOver = false;
                var type = attrs.trackIframeClick;

                $window.addEventListener('blur', function () {
                    if (iframeMouseOver) {
                        //iFrame clicked
                        analyticsWrapperService.eventTrack(
                            'Customer Experience - Social Media Share Button Clicked - ' + type
                        );
                    }
                });

                element.on('mouseover', function () {
                    iframeMouseOver = true;
                });

                element.on('mouseout', function () {
                    iframeMouseOver = false;
                });
            }
        };
    }
]);
